import { get } from './client.js';

export const getRuntime = (orgId) => get(`/orgs/${orgId}/runtime`);
